/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntegrationTemplate from './integration-template';
import IntegrationTemplateDetail from './integration-template-detail';
import IntegrationTemplateUpdate from './integration-template-update';
import IntegrationTemplateDeleteDialog from './integration-template-delete-dialog';

const IntegrationTemplateRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntegrationTemplate />} />
    <Route path="new" element={<IntegrationTemplateUpdate />} />
    <Route path=":id">
      <Route index element={<IntegrationTemplateDetail />} />
      <Route path="edit" element={<IntegrationTemplateUpdate />} />
      <Route path="delete" element={<IntegrationTemplateDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntegrationTemplateRoutes;
